// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import constants from "@store/constants";
import EventCategories from "@store/Library/Components/Events/Common/EventCategories";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React from "react";

export interface EventDetailsCategoriesStyles {}
export const eventDetailsCategoriesStyles: EventDetailsCategoriesStyles = {};

const styles = eventDetailsCategoriesStyles;

const EventDetailsCategories = () => {
    const page = useCurrentPage();

    if (!page) {
        return null;
    }

    const {
        fields: { categoriesList },
    } = page;

    return <EventCategories categoriesList={categoriesList} />;
};

const widgetModule: WidgetModule = {
    component: EventDetailsCategories,
    definition: {
        group: constants.widgetGroup.eventDetails,
        allowedContexts: ["EventDetailsPage"] as any,
    },
};

export default widgetModule;
